export function clinicCalendarDate(iso: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Copenhagen',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(iso));
}

export function patientJournalPath(input: {
  patientId: string;
  appointmentId?: string | null;
  entryId?: string | null;
  entryDate?: string | null;
}): string {
  const params = new URLSearchParams();
  params.set('tab', 'journal');
  if (input.appointmentId) params.set('appointment', input.appointmentId);
  if (input.entryId) params.set('entry', input.entryId);
  if (input.entryDate) params.set('date', input.entryDate);
  return `/patients/${input.patientId}?${params.toString()}`;
}

/** Canonical calendar → patient Journal tab path. Hover card and details modal share this. */
export function appointmentJournalPath(
  appointment: {
    id: string;
    patient_id?: string | null;
    starts_at: string;
  },
  entryId?: string | null,
): string | null {
  if (!appointment.patient_id) return null;
  return patientJournalPath({
    patientId: appointment.patient_id,
    appointmentId: appointment.id,
    entryId,
    entryDate: clinicCalendarDate(appointment.starts_at),
  });
}

export type CalendarJournalArrivalAction =
  | { type: 'none' }
  | { type: 'create' }
  | { type: 'focus'; entryId: string; autoEdit: boolean };

export function resolveCalendarJournalAction(
  entries: Array<{
    id: string;
    appointment_id: string | null;
    discarded_at?: string | null;
    archived_at?: string | null;
    finalized_at: string | null;
    is_primary?: boolean | null;
  }>,
  appointmentId: string | null,
  preferredEntryId: string | null,
): CalendarJournalArrivalAction {
  const visible = entries.filter((entry) => !entry.discarded_at);
  if (preferredEntryId) {
    const preferred = visible.find((entry) => entry.id === preferredEntryId);
    if (preferred) {
      return { type: 'focus', entryId: preferred.id, autoEdit: !preferred.finalized_at };
    }
  }
  if (appointmentId) {
    const linked =
      visible.find(
        (entry) => entry.appointment_id === appointmentId && entry.is_primary !== false,
      ) ?? visible.find((entry) => entry.appointment_id === appointmentId);
    if (linked) {
      return { type: 'focus', entryId: linked.id, autoEdit: !linked.finalized_at };
    }
    return { type: 'create' };
  }
  return { type: 'none' };
}
